// extracted by mini-css-extract-plugin
module.exports = {"sideBar":"package_sideBar__3Tu14","currentlyActive":"package_currentlyActive__1iBQR","bookNowBtn":"package_bookNowBtn__1bYb6","goToTop":"package_goToTop__xfv4s"};